import { memo } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '../../lib/styles';

export const SwitchBase = ({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'w-8 shrink-0 items-center rounded-full',
        'border border-transparent shadow-xs transition-all outline-none',
        'peer data-[state=checked]:bg-bg-inter-primary-default data-[state=unchecked]:bg-bg-inter-secondary-hover dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem]',
        'dark:data-[state=checked]:bg-white',
        'cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:ring-1 focus-visible:ring-border-input-select focus-visible:ring-offset-2',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block',
          'size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
          'bg-bg-sur-primary dark:bg-bg-inter-primary-default',
        )}
      />
    </SwitchPrimitive.Root>
  );
};

export const Switch = memo(SwitchBase);
